import { render, staticRenderFns } from "./beta-tag.html?vue&type=template&id=79afda29&scoped=true&external"
import script from "./beta-tag.js?vue&type=script&lang=js&external"
export * from "./beta-tag.js?vue&type=script&lang=js&external"
import style0 from "./beta-tag.scss?vue&type=style&index=0&id=79afda29&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79afda29",
  null
  
)

export default component.exports